// extracted by mini-css-extract-plugin
module.exports = {"signedPayload":"Verify_signedPayload__5LuML","verifyBlock":"Verify_verifyBlock__2dRVX"};